import { render, staticRenderFns } from "./CharacterEditPage.vue?vue&type=template&id=1690247b&scoped=true"
import script from "./CharacterEditPage.vue?vue&type=script&lang=ts"
export * from "./CharacterEditPage.vue?vue&type=script&lang=ts"
import style0 from "./CharacterEditPage.vue?vue&type=style&index=0&id=1690247b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690247b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1690247b')) {
      api.createRecord('1690247b', component.options)
    } else {
      api.reload('1690247b', component.options)
    }
    module.hot.accept("./CharacterEditPage.vue?vue&type=template&id=1690247b&scoped=true", function () {
      api.rerender('1690247b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/CharacterEditPage.vue"
export default component.exports